import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './CongratulationsStyle'
import SmilingEmoji from '../../../assets/Images/SmilingEmoji.png'
import Button from '../../../Components/Button/Button'

import { useNavigate } from 'react-router-dom'

const CCCongratulationsPage = ({
  title = 'Congratulations!',
  subtitle = 'You have successfully completed your credit card application process.',
  message = "We will contact you soon to update you on the progress of your credit card application."
 }) => {
  const navigate = useNavigate()
  const classes = useStyles()

  return (
    <Box className={classes.CongratulationsContainer}>
      <Box className={classes.CongratulationsBox}>
        <img
          className={classes.SmilingEmoji}
          src={SmilingEmoji}
          alert=''
          alt=''
        />
        <Typography className={classes.CongratulationsText}>
          {title}
        </Typography>
        <Typography className={classes.ProcessText}>
          <strong>
            {subtitle}
          </strong>
          <br />
          <br />
          {message}
        </Typography>
        <Button
          className={classes.ThankYouBtn}
          Title='THANK YOU'
          onClick={() => {
            navigate(`/my-applications`)
          }}
        />
      </Box>
    </Box>
  )
}

export default CCCongratulationsPage
